import { LoadableBackground } from '@confluence/loadable';

export const SatisfactionSurveysLoader = LoadableBackground({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-SatisfactionSurveys" */ './SatisfactionSurveys'))
			.SatisfactionSurveys,
});
